import React, { useState, useEffect } from 'react';
import { Card } from 'antd';
import PageLayout from '../../components/layout/PageLayout';
import collectionsService from '../../services/collectionsService';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { useNotify } from '../../context/NotificationContext';
import CollectionDetailsForm from '../../components/collections/CollectionDetailsForm';
import { useCommon } from '../../context/CommonContext';
const AddCollection = () => {
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { user } = useUser();
  const notify = useNotify();
  const { setPageTitle } = useCommon();
  const onSubmit = async (values) => {
    try {
      setSubmitting(true);
      const payload = {
        name: values.name,
        label: values.label || null,
        heading: values.heading || null,
        description: values.description || null,
        icon_image: values.icon_image || null,
        image: values.image || null,
        slug: values.slug || undefined,
        is_manual: values.is_manual || false,
        fk_template_id: values.fk_template_id || null,
        fk_category_id: values.fk_category_id || null,
        multilingual_data: values.multilingual_data || [],
      };
      const res = await collectionsService.createCollection(payload);
      if (res?.data?.status) {
        notify.success({ message: 'Collection created successfully' });
        const newId = res.data.data?.collection_id;
        if (newId) navigate(`/collections/edit/${newId}`);
        else navigate('/collections');
      } else {
        notify.error({ message: 'Failed to create collection' });
      }
    } catch (e) {
      notify.error({ message: e?.data?.message || 'Failed to create collection' });
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    setPageTitle("Add Collection");
  }, []);

  return (
    <PageLayout title="Add Collection" desc="Create a new collection" avatar={user?.avatar}>
      <Card>
        <CollectionDetailsForm
          initialValues={{ is_manual: false, icon_image: null, image: null }}
          loading={submitting}
          onSubmit={onSubmit}
          onBack={() => navigate('/collections')}
        />
      </Card>
    </PageLayout>
  );
};

export default AddCollection;
